import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import One from "../../../images/Strategic Pan/1.jpg";
import Two from "../../../images/Strategic Pan/2.jpg";
import Three from "../../../images/Strategic Pan/3.jpg";
import Four from "../../../images/Strategic Pan/4.jpg";
import Five from "../../../images/Strategic Pan/5.jpg";
import Six from "../../../images/Strategic Pan/6.jpg";
import Seven from "../../../images/Strategic Pan/7.jpg";
import Eight from "../../../images/Strategic Pan/8.jpg";
import Nine from "../../../images/Strategic Pan/9.jpg";
import Ten from "../../../images/Strategic Pan/10.jpg";
import Eleven from "../../../images/Strategic Pan/11.jpg";
import Twelve from "../../../images/Strategic Pan/12.jpg";
import Thirteen from "../../../images/Strategic Pan/13.jpg";
import Forteen from "../../../images/Strategic Pan/14.jpg";
import Fifteen from "../../../images/Strategic Pan/15.jpg";
import Sixteen from "../../../images/Strategic Pan/16.jpg";
import Seventeen from "../../../images/Strategic Pan/17.jpg";
import Eighteen from "../../../images/Strategic Pan/18.jpg";
import Nineteen from "../../../images/Strategic Pan/19.jpg";
import "../../../style/focusArea/strategicPlan.css";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const StrategicPlan = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Strategic Plan`;
  }, []);

  const shareUrl = "https://developmentconcerncht.org/focusArea/strategic-plan";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="strategicPlan_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>Strategic Plan</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="strategicPlan_wrapper">
          <div className="container">
            <h2>Our Strategic Plan</h2>
            <div className="strategic_plan">
              <img src={One} alt="" />
              <img src={Two} alt="" />
              <img src={Three} alt="" />
              <img src={Four} alt="" />
              <img src={Five} alt="" />
              <img src={Six} alt="" />
              <img src={Seven} alt="" />
              <img src={Eight} alt="" />
              <img src={Nine} alt="" />
              <img src={Ten} alt="" />
              <img src={Eleven} alt="" />
              <img src={Twelve} alt="" />
              <img src={Thirteen} alt="" />
              <img src={Forteen} alt="" />
              <img src={Fifteen} alt="" />
              <img src={Sixteen} alt="" />
              <img src={Seventeen} alt="" />
              <img src={Eighteen} alt="" />
              <img src={Nineteen} alt="" />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StrategicPlan;
